<template>
  <div>
    <el-container style=" border: 1px solid #eee">
      <el-aside width="200px"
                style="background-color: rgb(238, 241, 246)">
        <el-menu>
          <el-menu-item @click="index(1)">
            <template slot="title"><i class="el-icon-picture"></i>轮播管理</template>
          </el-menu-item>
          <el-menu-item @click="index(2)">
            <template slot="title"><i class="el-icon-document-add"></i>采购管理</template>
          </el-menu-item>
          <el-menu-item @click="index(3)">
            <template slot="title"><i class="el-icon-chat-dot-square"></i>配置管理</template>
          </el-menu-item>
          <el-menu-item @click="index(4)">
            <template slot="title"><i class="el-icon-coin"></i>公告管理</template>
          </el-menu-item>
          <el-menu-item @click="index(5)">
            <template slot="title"><i class="el-icon-s-tools"></i>流水管理</template>
          </el-menu-item>
          <el-menu-item @click="index(6)">
            <template slot="title"><i class="el-icon-s-promotion"></i>圈子管理</template>
          </el-menu-item>
          <el-menu-item @click="index(7)">
            <template slot="title"><i class="el-icon-s-platform"></i>用户管理</template>
          </el-menu-item>
          <el-menu-item @click="index(8)">
            <template slot="title"><i class="el-icon-s-platform"></i>认证管理</template>
          </el-menu-item>
          <el-menu-item @click="index(9)">
            <template slot="title"><i class="el-icon-s-platform"></i>成单管理</template>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-container>
        <banner v-if="showbanner"></banner>
        <caigouchange v-if="showcaigou"></caigouchange>
        <config v-if="showconfig"></config>
        <gonggao v-if="showcgonggao"></gonggao>
        <liushui v-if="showliushui"></liushui>
        <quanzi v-if="showquanzi"></quanzi>
        <user v-if="showuser"></user>
        <renzheng v-if="showrenzheng"></renzheng>
        <chendan v-if="showchendan"></chendan>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import banner from '../view/jgbanner.vue'
import caigouchange from '../view/jgcaigouinfo.vue'
import config from '../view/jgconfig.vue'
import gonggao from '../view/jggonggao.vue'
import liushui from '../view/jgliushui.vue'
import quanzi from '../view/jgquanzi.vue'
import user from '../view/jguser.vue'
import renzheng from '../view/jgshening.vue'
import chendan from '../view/jgchengdan.vue'
export default {
  data () {
    const item = {
      date: '2016-05-02',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1518 弄'
    }
    return {
      showbanner: false,
      showcaigou: false,
      showconfig: false,
      showcgonggao: false,
      showliushui: false,
      showquanzi: false,
      showuser: false,
      showrenzheng: false,
      showchendan:false,
      tableData: Array(20).fill(item)
    }
  },
  components: {
    banner,
    caigouchange,
    config,
    gonggao,
    liushui,
    quanzi,
    user,
    renzheng,
    chendan
  },
  mounted () {
    var phone = localStorage.getItem('phone')
    console.log(phone)
    if (phone === '' || phone === undefined || phone === null) {
      this.$router.push('/login')
    }
    this.cheeckadmin(phone)
  },
  methods: {
    cheeckadmin(phone){
      this.$http({
        url: this.global.apiUrl + '/jxjg/jguser/checkadmin',
        method: 'get',
        params: {
          'phone': phone
        }
      }).then((data) => {
        data = data.body
        if (data && data.code === 0) {
          
        } else {
          this.$router.push('/login')
        }
      })
    },
    index (index) {
      console.log(index)
      this.closeall()
      if (index === 1) {
        this.showbanner = true
      }
      if (index === 2) {
        this.showcaigou = true
      }
      if (index === 3) {
        this.showconfig = true
      }
      if (index === 4) {
        this.showcgonggao = true
      }
      if (index === 5) {
        this.showliushui = true
      }
      if (index === 6) {
        this.showquanzi = true
      }
      if (index === 7) {
        this.showuser = true
      }
      if (index === 8) {
        this.showrenzheng = true
      }
      if (index === 9) {
        this.showchendan = true
      }
    },
    closeall () {
      this.showbanner = false
      this.showcaigou = false
      this.showconfig = false
      this.showcgonggao = false
      this.showliushui = false
      this.showquanzi = false
      this.showuser = false
      this.showrenzheng = false
      this.showchendan=false
    }
  }
}
</script>

<style>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 60px;
}
.el-aside {
  color: #333;
}
.el-container {
  height: 900px;
}
.mod-config {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue